import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://milestnireopjlppotne.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1pbGVzdG5pcmVvcGpscHBvdG5lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDEwMzAzMDcsImV4cCI6MjAxNjYwNjMwN30.dBI-GoWI8w32C8oPw0aOf7tJbnvpMEikOc5pqTU5lEc";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
